module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "svg-filters-root"
  }, [(_vm.show) ? _c('svg', {
    staticClass: "svg-filters-root",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "filter-blur-x",
      "x": "-20%",
      "y": "0",
      "width": "140%",
      "height": "100%"
    }
  }, [_c('feGaussianBlur', {
    attrs: {
      "in": "SourceGraphic",
      "stdDeviation": "12,0"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter-blur-y",
      "x": "0",
      "y": "20%",
      "width": "100%",
      "height": "140%"
    }
  }, [_c('feGaussianBlur', {
    attrs: {
      "in": "SourceGraphic",
      "stdDeviation": "0,20"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00bec544"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg-filter/svg-filter.vue
// module id = 176
// module chunks = 0